/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-props-no-spreading */

import { Collapse, Space } from "antd";
import React from "react";
import {
  getMenuParentElements,
  getParentMenuChildren,
  toggleCookieSettings,
} from "../../menuHelpers";
import { Logo } from "../Logo/Logo";

const { Panel } = Collapse;

// Collapse menu for mobile
export const MobileMenu = (props) => {
  const {
    datalinks,
    mcontact,
    megacta,
    sitemegamenu,
    sitemegamenucontact,
    sitemegamenumuotolevy,
  } = props;

  const parentMenuElements = getMenuParentElements(
    sitemegamenu.concat(sitemegamenumuotolevy), // NOTE: concat megamenu and muotolevy-menu
  );
  const [contactParentMenu] = getMenuParentElements(sitemegamenucontact);
  const { menuChildren: contactMenuChildren } = getParentMenuChildren(
    sitemegamenucontact,
    contactParentMenu.ID,
  );

  return (
    <div className="megamenu__wrapper">
      <div className="megamenu__container">
        {megacta && (
          <ul className="megamenu__top menu">
            {megacta.map((item) => (
              <li>
                <a href={item.url}>{item.title}</a>
              </li>
            ))}
          </ul>
        )}
        {parentMenuElements &&
          parentMenuElements.map((parentMenu) => {
            const {
              menuChildren,
              menuChildrenWithChildren,
              menuHasNoGrandChildren,
            } = getParentMenuChildren(
              sitemegamenu.concat(sitemegamenumuotolevy), // NOTE: concat megamenu and muotolevy-menu
              parentMenu.ID,
            );
            return (
              <Collapse expandIconPosition="right" ghost>
                <Panel header={parentMenu.title} key="1">
                  {!menuHasNoGrandChildren && (
                    <Collapse
                      expandIconPosition="right"
                      ghost
                      defaultActiveKey="2"
                    >
                      <Panel header={menuChildrenWithChildren[0].title} key="2">
                        <ul>
                          {menuChildrenWithChildren.map((item) => (
                            <li className={`${item.classes[0]} no-border`}>
                              {item.children && (
                                <ul>
                                  {item.children.map((child) => (
                                    <li
                                      className={`${child.classes[0]} no-border bold`}
                                    >
                                      <a href={child.url}>{child.title}</a>
                                    </li>
                                  ))}
                                </ul>
                              )}
                            </li>
                          ))}
                        </ul>
                      </Panel>
                    </Collapse>
                  )}
                  <ul>
                    {parentMenu.url.startsWith("http") && (
                      <li className={`${parentMenu.classes[0]} no-border`}>
                        <a href={parentMenu.url}>{parentMenu.title}</a>
                      </li>
                    )}
                    {menuChildren.map((item) => (
                      <li className={`${item.classes[0]} no-border`}>
                        <a href={item.url}>{item.title}</a>
                      </li>
                    ))}
                  </ul>
                </Panel>
              </Collapse>
            );
          })}

        <div className="megamenu__right">
          {contactMenuChildren.length > 0 && (
            <ul>
              <Space size="small" direction="vertical">
                {contactMenuChildren.map((item) => (
                  <li className="no-border">
                    <a href={item.url}>{item.title}</a>
                  </li>
                ))}
              </Space>
            </ul>
          )}
        </div>

        <Space size="large" direction="vertical">
          <Logo />
          <div className="megamenu__contact">
            <div dangerouslySetInnerHTML={{ __html: mcontact }} />
          </div>
        </Space>

        <div className="megamenu__footer">
          {datalinks && (
            <ul>
              {datalinks.map((item, index, array) =>
                index === array.length - 1 ? (
                  <li>
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        toggleCookieSettings();
                      }}
                    >
                      {item.title}
                    </a>
                  </li>
                ) : (
                  <li>
                    <a href={item.url}>{item.title}</a>
                  </li>
                ),
              )}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

export default MobileMenu;
